import { latestComics } from "@/mocks/homeData";

export default function Latest() {
  return (
    <section id="latest" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm font-bold text-accent-600">
              本周新上架 · 抢先阅读
            </span>
            <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
              新作速递
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-700 md:text-base">
              编辑部每周精选上新的创意短篇漫画，第一时间更新，不错过任何惊喜。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {latestComics.map((c, i) => (
            <article
              key={c.id}
              className="group flex gap-4 overflow-hidden rounded-xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-200 hover:bg-accent-50"
            >
              <div className="relative shrink-0">
                <img
                  src={c.cover}
                  alt={`${c.title}短篇漫画封面`}
                  className="aspect-[3/4] w-24 rounded-lg object-cover object-top md:w-28"
                />
              </div>
              <div className="flex flex-1 flex-col">
                <div className="flex items-center gap-2">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-background-50">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h4 className="font-heading text-lg text-foreground-950">
                    {c.title}
                  </h4>
                </div>
                <span className="mt-2 inline-flex w-fit items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-bold text-secondary-900">
                  <i className="ri-price-tag-3-line" />
                  {c.tag}
                </span>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {c.intro}
                </p>
                <div className="mt-auto flex items-center gap-4 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {c.mins}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {(c.views / 1000).toFixed(1)}k
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-accent-700">
                    去阅读
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}